import { useParticipantLocation } from "modules/participants/hooks";
import { useAppDispatch } from "store/hooks";
import { updateMapTargetState } from "modules/mapNavigation/redux/mapNavigationSlice";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectHoveredUserId } from "../../redux";

export const LOCATE_ATTENDEE_TIMEOUT = 2000;

export const LocateAttendeeHandler = () => {
  const hoveredUserId = useSelector(selectHoveredUserId);
  const dispatch = useAppDispatch();
  const { locateUser } = useParticipantLocation();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (hoveredUserId) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        const userLocation = locateUser(hoveredUserId);

        if (userLocation.status === "currentFloor") {
          dispatch(
            updateMapTargetState({
              ...userLocation.coordinates,
              x: null,
              y: null,
              zoom: null,
              customAnimationDurationOverride: 200,
            }),
          );
        }
      }, LOCATE_ATTENDEE_TIMEOUT);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [dispatch, hoveredUserId, locateUser]);

  return null;
};
